import React from 'react';
import styles from './Hint.module.scss';
import { Button } from 'antd';

export const Hint = ({ render, title = '', setVisible }) => {
  if (typeof render !== 'function') return null;

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        <Button
          icon="close"
          className={styles.close}
          onClick={setVisible}
        />
      </div>
      <div className={styles.body}>{render()}</div>
    </div>
  );
};
